module.exports = __webpack_public_path__ + "static/media/impiantoGreen.a8d2dad0.png";